module.exports = __webpack_public_path__ + "ifeng_logo.ee2f112a.png";